import { Link } from "react-router-dom";
import { cssX, FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";

export type SearchAction =
  | { type: 'link'; name: string; to: string }
  | { type: 'button'; name: string; onClick?: () => void };

interface SearchResultItemActionsProps {
    actions?: SearchAction[];
}
export const SearchResultItemActions: FCX<SearchResultItemActionsProps> = ({
    actions,
}) => {
    if (!actions) return null;

    return (
        <div className="ToolSearch__itemContent">
            {
                actions.map((action) => {
                    if (action.type === 'link') {
                        return (
                            <Link
                                className={cn(cssX('Dropdown__item-action'), "ToolSearch__itemActionLink")}
                                key={action.name}
                                to={action.to || ''}
                                data-testid={`buttonHeaderSearchResult${action.name}`}
                            >
                                {action.name}
                            </Link>
                        )
                    }
                    if (action.type === 'button') {
                        return (
                            <div
                                className={cn(cssX('Dropdown__item-action'), "ToolSearch__itemActionButton")}
                                key={action.name}
                                style={{ display: 'flex'}}
                                onClick={() => action.onClick?.()}
                                data-testid={`buttonHeaderSearchResult${action.name}`}
                            >
                                {action.name}
                            </div>
                        )
                    }
                    return null;
                })
            }
        </div>
    )
};
